import { compose } from 'redux';
import { globals } from '@yola/ws-sdk';
import constants from '../constants';
import getCompiledFontPairConfig from './get-compiled-font-pair-config';
import getSelectorByGlobalId from './get-selector-by-global-id';
import setCurrentFont from './set-current-font';
import updateCustomFontPairs from './update-custom-font-pairs';

const { GLOBAL_HEADER_CODE } = constants;

const persistTextEditingFontPairChanges = ({
  storeCustomFonts,
  updatedCustomFontsList,
  newConfig,
  fontsVariable,
  customFontsTemplate,
  onFontPairsChanged,
}) => {
  updateCustomFontPairs(storeCustomFonts, updatedCustomFontsList);

  let fontConfig = newConfig;

  if (newConfig.isCustom) {
    fontConfig = getCompiledFontPairConfig(newConfig);
  }

  const fontSelector = getSelectorByGlobalId(fontsVariable, GLOBAL_HEADER_CODE);

  globals.operations.changeGlobalContent(
    GLOBAL_HEADER_CODE,
    (global) => {
      const setCurrentFontCurry = (globalItem) =>
        setCurrentFont(globalItem, fontConfig, customFontsTemplate, fontSelector);

      return compose(setCurrentFontCurry)(global);
    },
    false
  );

  onFontPairsChanged();
};

export default persistTextEditingFontPairChanges;
